import EditIcon from '@mui/icons-material/Edit';
import StoreIcon from '@mui/icons-material/Store';

function EditICCBranchIcon() {
    return (
        <div style={{ maxWidth: "24px" }}>
            <StoreIcon />
            <EditIcon sx={{ fontSize: "15px", marginLeft: "-10px", color: "#757575" }} />
        </div>
    )
}

export default EditICCBranchIcon;